import { RouteObject } from 'react-router-dom';
import StatisticsDashboard from '../StatisticsDashboard';

export const DashboardRoutes: RouteObject[] = [
  {
    path: 'dashboard',
    element: <StatisticsDashboard />,
  },
];
